import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';


const baseUrl = process.env.REACT_APP_BASE_URL;


export const tourApi = createApi({
  reducerPath: 'tourApi',
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
  }),

  endpoints: (builder) => ({
    getTour: builder.query({
      query: (token) => `tours?access_token=${token}`,
    }),

    updateTour: builder.mutation({
      query: (params) => {
        console.log('api mutation', params )
        return  {
          method: 'PUT',
          url: `tours/${params.id}?access_token=${params.token}`,
          body: params.updateTours, 
        }
      }
    }),
    deleteTour: builder.mutation({
      query: (body) => ({
        url: `tours/${body.id}?access_token=${body.token}`,
        method: 'DELETE',
      }),
    }),

    createTour: builder.mutation({
      query: (body) => ({
        url: `tours?access_token=${body.token}`,
        method: 'POST',
        body: body.formData,
      }),
    }),

    getRegions: builder.query({
      query: (token) => `regions?access_token=${token}`,
    }),

  }),
});

export const {
    useGetTourQuery,
    useCreateTourMutation,
    useUpdateTourMutation,
    useDeleteTourMutation,
    useGetRegionsQuery
} = tourApi;